export default __webpack_public_path__ + "static/media/left_tree.df032b36.svg";